import { defineStore } from 'pinia';
import {
  initialUsers,
  initial_filters,
} from '../models/user_model.js';
import api from '@/services/api';
import { getParamsUrl } from '../user_utils.js';

export const useUserStore = defineStore('userStore', {
  state: () => ({
    user: { ...initialUsers },
    filters: { ...initial_filters },
    users: [],
    usuariosDisponibles: [],
    page: 1,
  }),
  actions: {
    async findAllUsersHTTP(params) {
      const result = await api.get(
        `/usuario?${getParamsUrl({ page: +this.page, ...this.filters, ...params })}`,
      );
      if (result && result.data && result.data.length > 0) {
        this.users.push(...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },
    async loadUsuariosDisponibles() {
      try {
        const response = await api.get(`/usuario?${getParamsUrl({ limit: 300, page: 1 })}`);
        if (response && response.data) {
          this.usuariosDisponibles = response.data.map((u) => ({
            Codigo: u.Codigo,
            Descripcion: `${u.Nombre} ${u.Apellido}`,
          }));
        }
      } catch (error) {
        console.error('Error al cargar usuarios disponibles', error);
      }
    },
    async findAllVendedoresHTTP() {
      const result = await api.get(`/usuario?page=1&offset=0&sortBy=Codigo&sort=ASC&RolUsuario=1`);
      if (result && result.data && result.data.length > 0) {
        result.data.forEach((v) => (v.Descripcion = `${v.Usuario} (${v.Nombre} ${v.Apellido})`));
        return result.data;
      }
      return false;
    },
    async newUserHTTP() {
      delete this.user.RepetirPassword;
      const response = await api.post('/usuario', this.user);
      if (response.status === 200 || response.status === 201) {
        this.resetUser();
        return;
      }
    },
    async findUserByCodigoHTTP(codigo) {
      try {
        const result = await api.get(`/usuario/${codigo}`);
        if (result && result.data) {
          this.user = result.data;
        }
      } catch (error) {
        console.error('Error en findUserByCodigoHTTP:', error);
      }
    },
    async updateUserHTTP() {
      const codigo = this.user.Codigo;

      const payload = {
        Codigo: this.user.Codigo,
        Usuario: this.user.Usuario,
        Nombre: this.user.Nombre,
        Apellido: this.user.Apellido,
        Activo: this.user.Activo,
        CodigoUsuarioCreacion: this.user.CodigoUsuarioCreacion,
        FechaCreacion: this.user.FechaCreacion,
        CodigoUsuarioActualizacion: this.user.CodigoUsuarioActualizacion,
        FechaActualizacion: this.user.FechaActualizacion,
        Comision: this.user.Comision,
        PuestoUsuario: this.user.PuestoUsuario ?? [],
        UsuariosRelacionados: this.user.UsuariosRelacionados ?? [],
        Email: this.user.Email,
        TelefonoCelular: this.user.TelefonoCelular,
        TelefonoLinea: this.user.TelefonoLinea,
        Interno: this.user.Interno,
      };

      const response = await api.patch(`/usuario/${codigo}`, payload);
      if (response.status === 200) {
        this.resetUser();
      }
    },
    async updateUserRolesHTTP(codigo, roleIds) {
      const payload = { roleIds };
      const response = await api.patch(`/usuario/${codigo}/roles`, payload);
      return response?.data;
    },
    async searchUsersHTTP(query, codigoUsuario) {
      const url = `/usuario?Fullname=${encodeURIComponent(query)}&page=1`;
      const result = await api.get(url);
      if (result && result.data && result.data.length > 0) {
        return [...result.data];
      }
    },
    async changePassword() {
      const codigo = this.user.Codigo;
      const userPassword = {
        Codigo: this.user.Codigo,
        Password: this.user.Password,
        RepetirPassword: this.user.RepetirPassword,
      };
      await api.patch(`/usuario/${codigo}/changePassword`, userPassword);
    },
    async firstUsers() {
      this.setPage(1);
      this.emptyList();
      await this.findAllUsersHTTP();
    },
    resetUser() {
      this.user = { ...initialUsers };
    },
    setPage(page) {
      this.page = page;
    },
    emptyList() {
      this.users = [];
    },
    resetFilter() {
      this.filters = { ...initial_filters };
    },
  },
});
